import { Redirect } from 'react-router-dom';
import React from 'react';
import Auth from 'utils/auth';

import Spinner from 'components/base/Spinner';

import Mutations from 'graphql/Mutations';

class SignIn extends React.Component {
  state = {
    completed: false,
    error: false,
  }

  render() {
    if (this.state.completed) return <Redirect to={{ pathname: '/' }} />;
    if (this.state.error) return <Redirect to={{ pathname: '/sign-in' }} />;

    return (
      <Mutations.RedeemMagicLink>
        {(submit) => {
          submit(
            { token: this.props.match.params.token },
            (result) => {
              Auth.login(
                result.data.redeemMagicLink.jwt,
                result.data.redeemMagicLink.user.role
              );
              this.setState({ completed: true });
            },
            () => {
              this.setState({ error: true });
            }
          );
          return <Spinner />;
        }}
      </Mutations.RedeemMagicLink>
    );
  }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/utils/signIn.js